import React from 'react';
    import { Film, Mail, Phone, MapPin } from 'lucide-react';
    import NewsletterSignup from './NewsletterSignup';
    import {
      trackHeaderFooterClick,
      detectDeviceType,
    } from '../utils/headerFooterAnalytics';

    const Footer = () => {
      const device =
        typeof window !== 'undefined' ? detectDeviceType() : 'desktop';

      const handleQuickLinkClick = (id, label, href) => {
        trackHeaderFooterClick('footer', `quickLink:${id}`, {
          label,
          href,
          device,
        });
      };

      const handleContactClick = (id, label, href) => {
        trackHeaderFooterClick('footer', `contact:${id}`, {
          label,
          href,
          device,
        });
      };

      return (
        <footer
          className="bg-gray-900 text-white"
          data-component-path="client/src/components/Footer.jsx"
          data-component-line="7:4"
          data-component-id="client/src/components/Footer.jsx:7:4"
        >
          <div
            className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12"
            data-component-path="client/src/components/Footer.jsx"
            data-component-line="8:6"
            data-component-id="client/src/components/Footer.jsx:8:6"
          >
            <div
              className="mb-12"
              data-component-path="client/src/components/Footer.jsx"
              data-component-line="10:8"
              data-component-id="client/src/components/Footer.jsx:10:8"
            >
              <NewsletterSignup />
            </div>

            <div
              className="grid grid-cols-1 md:grid-cols-3 gap-8"
              data-component-path="client/src/components/Footer.jsx"
              data-component-line="14:8"
              data-component-id="client/src/components/Footer.jsx:14:8"
            >
              <div
                data-component-path="client/src/components/Footer.jsx"
                data-component-line="16:10"
                data-component-id="client/src/components/Footer.jsx:16:10"
              >
                <div
                  className="flex items-center gap-3 mb-4"
                  data-component-path="client/src/components/Footer.jsx"
                  data-component-line="17:12"
                  data-component-id="client/src/components/Footer.jsx:17:12"
                >
                  <div
                    className="w-10 h-10 bg-gradient-to-br from-blue-600 to-blue-400 rounded-lg flex items-center justify-center"
                    data-component-path="client/src/components/Footer.jsx"
                    data-component-line="18:14"
                    data-component-id="client/src/components/Footer.jsx:18:14"
                  >
                    <Film
                      className="w-6 h-6 text-white"
                      data-component-path="client/src/components/Footer.jsx"
                      data-component-line="19:16"
                      data-component-id="client/src/components/Footer.jsx:19:16"
                    />
                  </div>
                  <h3
                    className="text-xl font-bold hero-title"
                    data-component-path="client/src/components/Footer.jsx"
                    data-component-line="21:14"
                    data-component-id="client/src/components/Footer.jsx:21:14"
                  >
                    Shikdar Films
                  </h3>
                </div>
                <p
                  className="text-gray-400 text-sm leading-relaxed"
                  data-component-path="client/src/components/Footer.jsx"
                  data-component-line="23:12"
                  data-component-id="client/src/components/Footer.jsx:23:12"
                >
                  Creating compelling stories through drama, films, and music
                  videos with talented Bangladeshi actors. Showcasing our
                  culture to the world.
                </p>
              </div>

              <div
                data-component-path="client/src/components/Footer.jsx"
                data-component-line="29:10"
                data-component-id="client/src/components/Footer.jsx:29:10"
              >
                <h4
                  className="text-lg font-semibold mb-4 section-title"
                  data-component-path="client/src/components/Footer.jsx"
                  data-component-line="30:12"
                  data-component-id="client/src/components/Footer.jsx:30:12"
                >
                  Quick Links
                </h4>
                <ul
                  className="space-y-2"
                  data-component-path="client/src/components/Footer.jsx"
                  data-component-line="31:12"
                  data-component-id="client/src/components/Footer.jsx:31:12"
                >
                  <li
                    data-component-path="client/src/components/Footer.jsx"
                    data-component-line="32:14"
                    data-component-id="client/src/components/Footer.jsx:32:14"
                  >
                    <a
                      href="/"
                      onClick={() =>
                        handleQuickLinkClick('home', 'Home', '/')
                      }
                      className="text-gray-400 hover:text-blue-400 transition-colors duration-200"
                      data-component-path="client/src/components/Footer.jsx"
                      data-component-line="33:16"
                      data-component-id="client/src/components/Footer.jsx:33:16"
                    >
                      Home
                    </a>
                  </li>
                  <li
                    data-component-path="client/src/components/Footer.jsx"
                    data-component-line="35:14"
                    data-component-id="client/src/components/Footer.jsx:35:14"
                  >
                    <a
                      href="/awards"
                      onClick={() =>
                        handleQuickLinkClick('awards', 'Awards', '/awards')
                      }
                      className="text-gray-400 hover:text-blue-400 transition-colors duration-200"
                      data-component-path="client/src/components/Footer.jsx"
                      data-component-line="36:16"
                      data-component-id="client/src/components/Footer.jsx:36:16"
                    >
                      Awards
                    </a>
                  </li>
                  <li
                    data-component-path="client/src/components/Footer.jsx"
                    data-component-line="38:14"
                    data-component-id="client/src/components/Footer.jsx:38:14"
                  >
                    <a
                      href="/team"
                      onClick={() =>
                        handleQuickLinkClick('team', 'Team', '/team')
                      }
                      className="text-gray-400 hover:text-blue-400 transition-colors duration-200"
                      data-component-path="client/src/components/Footer.jsx"
                      data-component-line="39:16"
                      data-component-id="client/src/components/Footer.jsx:39:16"
                    >
                      Team
                    </a>
                  </li>
                  <li
                    data-component-path="client/src/components/Footer.jsx"
                    data-component-line="41:14"
                    data-component-id="client/src/components/Footer.jsx:41:14"
                  >
                    <a
                      href="/careers"
                      onClick={() =>
                        handleQuickLinkClick(
                          'careers',
                          'Careers',
                          '/careers'
                        )
                      }
                      className="text-gray-400 hover:text-blue-400 transition-colors duration-200"
                      data-component-path="client/src/components/Footer.jsx"
                      data-component-line="42:16"
                      data-component-id="client/src/components/Footer.jsx:42:16"
                    >
                      Careers
                    </a>
                  </li>
                </ul>
              </div>

              <div
                data-component-path="client/src/components/Footer.jsx"
                data-component-line="47:10"
                data-component-id="client/src/components/Footer.jsx:47:10"
              >
                <h4
                  className="text-lg font-semibold mb-4 section-title"
                  data-component-path="client/src/components/Footer.jsx"
                  data-component-line="48:12"
                  data-component-id="client/src/components/Footer.jsx:48:12"
                >
                  Contact Us
                </h4>
                <div
                  className="flex flex-col gap-3"
                  data-component-path="client/src/components/Footer.jsx"
                  data-component-line="49:12"
                  data-component-id="client/src/components/Footer.jsx:49:12"
                >
                  <div
                    className="flex items-start gap-3"
                    data-component-path="client/src/components/Footer.jsx"
                    data-component-line="50:14"
                    data-component-id="client/src/components/Footer.jsx:50:14"
                  >
                    <MapPin
                      className="w-5 h-5 text-blue-400 flex-shrink-0 mt-0.5"
                      data-component-path="client/src/components/Footer.jsx"
                      data-component-line="51:16"
                      data-component-id="client/src/components/Footer.jsx:51:16"
                    />
                    <span
                      className="text-gray-400 text-sm"
                      data-component-path="client/src/components/Footer.jsx"
                      data-component-line="52:16"
                      data-component-id="client/src/components/Footer.jsx:52:16"
                    >
                      Dhaka, Bangladesh
                    </span>
                  </div>
                  <div
                    className="flex items-start gap-3"
                    data-component-path="client/src/components/Footer.jsx"
                    data-component-line="54:14"
                    data-component-id="client/src/components/Footer.jsx:54:14"
                  >
                    <Mail
                      className="w-5 h-5 text-blue-400 flex-shrink-0 mt-0.5"
                      data-component-path="client/src/components/Footer.jsx"
                      data-component-line="55:16"
                      data-component-id="client/src/components/Footer.jsx:55:16"
                    />
                    <a
                      href="mailto:contact@shikdarfilms.com"
                      onClick={() =>
                        handleContactClick(
                          'email',
                          'Email',
                          'mailto:contact@shikdarfilms.com'
                        )
                      }
                      className="text-gray-400 text-sm hover:text-blue-400 transition-colors"
                      data-component-path="client/src/components/Footer.jsx"
                      data-component-line="56:16"
                      data-component-id="client/src/components/Footer.jsx:56:16"
                    >
                      contact@shikdarfilms.com
                    </a>
                  </div>
                  <div
                    className="flex items-start gap-3"
                    data-component-path="client/src/components/Footer.jsx"
                    data-component-line="58:14"
                    data-component-id="client/src/components/Footer.jsx:58:14"
                  >
                    <Phone
                      className="w-5 h-5 text-blue-400 flex-shrink-0 mt-0.5"
                      data-component-path="client/src/components/Footer.jsx"
                      data-component-line="59:16"
                      data-component-id="client/src/components/Footer.jsx:59:16"
                    />
                    <a
                      href="tel:+8801XXXXXXXX"
                      onClick={() =>
                        handleContactClick(
                          'phone',
                          'Phone',
                          'tel:+8801XXXXXXXX'
                        )
                      }
                      className="text-gray-400 text-sm hover:text-blue-400 transition-colors"
                      data-component-path="client/src/components/Footer.jsx"
                      data-component-line="60:16"
                      data-component-id="client/src/components/Footer.jsx:60:16"
                    >
                      +880 1XXX-XXXXXX
                    </a>
                  </div>
                </div>
              </div>
            </div>

            <div
              className="border-t border-gray-800 mt-8 pt-8 text-center"
              data-component-path="client/src/components/Footer.jsx"
              data-component-line="66:8"
              data-component-id="client/src/components/Footer.jsx:66:8"
            >
              <p
                className="text-gray-400 text-sm"
                data-component-path="client/src/components/Footer.jsx"
                data-component-line="67:10"
                data-component-id="client/src/components/Footer.jsx:67:10"
              >
                © {new Date().getFullYear()} Shikdar Films. All rights reserved.
              </p>
            </div>
          </div>
        </footer>
      );
    };

    export default Footer;